export default __webpack_public_path__ + "static/specific-segments-25e775ef9530993d3deabc8f35a693dd.png";